import React, { Component } from 'react';
interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
}
export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };
  public static getDerivedStateFromError(_: Error): State {
    return {
      hasError: true
    };
  }
  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }
  public render() {
    if (this.state.hasError) {
      return <div className="min-h-screen flex items-center justify-center bg-purple-50" data-id="element-468">
          <div className="text-center p-8" data-id="element-469">
            <h1 className="text-2xl font-bold text-purple-700 mb-4" data-id="element-470">
              Oops! Something went wrong.
            </h1>
            <p className="text-purple-600 mb-4" data-id="element-471">
              Don't worry, your story is safe! Please refresh the page to
              continue.
            </p>
            <button onClick={() => window.location.reload()} className="px-6 py-3 bg-purple-600 text-white rounded-full hover:bg-purple-700 transition-colors" data-id="element-472">
              Refresh Page
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}